import { render, staticRenderFns } from "./radar.md?vue&type=template&id=045f9c36&"
import script from "./radar.md?vue&type=script&lang=js&"
export * from "./radar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045f9c36')) {
      api.createRecord('045f9c36', component.options)
    } else {
      api.reload('045f9c36', component.options)
    }
    module.hot.accept("./radar.md?vue&type=template&id=045f9c36&", function () {
      api.rerender('045f9c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/api/radar.md"
export default component.exports